/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * Mapped Card Header component
 *
 * @file SubscriptionStatusBtn.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography, withStyles } from '@material-ui/core';

// Styles and common
import SubscriptionStatusBtnStyles from './styles/SubscriptionStatusBtnStyles';

const SubscriptionStatusBtn = ({
  classes,
  text,
  isSubscribed = true
}) => (
  <Typography
    variant="contained"
    classes={{ root: classes.container, label: classes.text }}
    className={isSubscribed ? 'subscribed' : 'unsubscribed'}
  >
    {text}
  </Typography>
);

SubscriptionStatusBtn.defaultProps = {
  text: '',
  isSubscribed: true
};

SubscriptionStatusBtn.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string,
  isSubscribed: PropTypes.bool
};

export default withStyles(SubscriptionStatusBtnStyles)(SubscriptionStatusBtn);
